// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"e245d768","75":"230bd99b","237":"302ba332","453":"51d8bfbf","460":"040c7abe","547":"8af7719d","954":"edf68e3b"}[chunkId] + ".chunk.js";
};